import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    public model: any[];

    constructor(public app: AppComponent, public appMain: AppMainComponent) {}

    ngOnInit() {
        this.model = [
            {
                label: 'Chamados', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/']
            },
            // {
            //     label: 'Cadastro', icon: 'pi pi-fw pi-id-card', routerLink: ['/cadastro'],
            //     items: [
            //         {label: 'Empresa', icon: 'pi pi-fw pi-align-left', routerLink: ['/cadastro/empresa']},
            //         {label: 'Usuário', icon: 'pi pi-fw pi-align-left', routerLink: ['/cadastro/usuario']},
            //         {label: 'Cliente', icon: 'pi pi-fw pi-align-left', routerLink: ['/cadastro/cliente']},
            //         // {label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel']},
            //         // {label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/uikit/invalidstate']},
            //     ]
            // },
            // {
            //     label: 'Técnica', icon: 'pi pi-fw pi-id-card', routerLink: ['/tecnica'],
            //     items: [
            //         {label: 'Atendimento', icon: 'pi pi-fw pi-align-left', routerLink: ['/tecnica/atendimento']},
            //         {label: 'Técnico', icon: 'pi pi-fw pi-align-left', routerLink: ['/tecnica/tecnico']},
            //     ] 
            // }
        ];
    }
}
